import { useState } from "react";
import { useActions } from "app/utils/hooks";
import { clearMediaState, fetchMedia } from "app/actions/media-library-data";
import { clearFilter } from "app/actions/filter";
import { FilterModel } from "app/models/FilterModel";
import { usePagination } from "app/utils/hooks/usePagination";

const DEFAULT_QUERY = {
  order: "desc",
  page: 1,
  perPage: 20,
};

export const useResourcesContainerModel = () => {
  const mediaActions = useActions({ fetchMedia, clearMediaState, clearFilter });
  const [filter, setFilter] = useState(null);

  const filterHandler = (filters: FilterModel) => {
    setFilter(filters);
  };

  const onClearFilters = () => {
    setFilter(null);
  };

  const { data, pending, sentryRef }: any = usePagination({
    initialParams: { ...DEFAULT_QUERY, ...filter },
    fetchData: (params, signal) => mediaActions.fetchMedia(params, signal),
    clearDataAction: () => {},
    dependencies: [filter],
  });

  return { data, pending, filterHandler, onClearFilters, sentryRef };
};
